import { axiosInstance } from 'boot/axios';

export function postContactForm({ commit }, payload) {
  var contactForm = new FormData();

  contactForm.set('CustomerNumber', payload.selectedCustomerNumber);
  contactForm.set('Subject', payload.selectedSubjectKey);
  contactForm.set('Question', payload.question);

  if (payload.extraData && payload.extraData.length > 0) {
    let i = 0;

    payload.extraData.forEach((extra) => {
      contactForm.set(`ExtraData[${i}].Key`, extra.key);
      contactForm.set(`ExtraData[${i}].Value`, extra.value);
      i++;
    });
  }

  if (payload.files && payload.files.length > 0) {
    payload.files.forEach((file) => contactForm.append('Files', file.file));
  }

  commit('setIsSavingContactForm', true);

  return axiosInstance.post('ContactForm', contactForm).finally(() => {
    commit('setIsSavingContactForm', false);
  });
}
